import { render, staticRenderFns } from "./PutAwayCartonsModal.vue?vue&type=template&id=46fbc890&scoped=true&"
import script from "./PutAwayCartonsModal.vue?vue&type=script&lang=js&"
export * from "./PutAwayCartonsModal.vue?vue&type=script&lang=js&"
import style0 from "./PutAwayCartonsModal.vue?vue&type=style&index=0&id=46fbc890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fbc890",
  null
  
)

export default component.exports